import { nanoid } from 'nanoid';

export const shortId = (length = 5) => nanoid(length);
